<template>
    <div>
        <div class="tw-flex tw-flex-col tw-items-start md:tw-flex-row tw-gap-4 tw-p-1">
            <div class="tw-flex tw-flex-col tw-w-full md:tw-w-1/2 tw-gap-4"><!-- left side -->
                <internal-table-section :has-button="false" class="tw-w-full">
                    <div class="tw-flex tw-flex-col">
                        <div class="tw-pb-2">
                            <v-text-field
                                :value="production.company"
                                :outlined="false"
                                readonly
                                label="Parent Company"
                            ></v-text-field>
                        </div>
                        <div class="tw-pb-2">
                            <v-text-field
                                :value="production.labour_relations"
                                :outlined="false"
                                readonly
                                label="Labour Relations"
                            ></v-text-field>
                        </div>
                        <div class="tw-flex tw-gap-3">
                            <v-text-field
                                :value="production.date_start"
                                :outlined="false"
                                readonly
                                hide-details
                                label="Start Date"
                                class="tw-w-1/2"
                            ></v-text-field>
                            <v-text-field
                                :value="production.date_wrap"
                                :outlined="false"
                                readonly
                                hide-details
                                label="Wrap Date"
                                class="tw-w-1/2"
                            ></v-text-field>
                        </div>
                    </div>
                </internal-table-section>

                <internal-table-section :has-button="false" section-title="Production Address" class="tw-w-full">
                    <div class="tw-flex tw-flex-col tw-px-4 tw-pt-3">
                        <div class="tw-pb-2">
                            <v-text-field
                                :value="production.company_name_internal"
                                :outlined="false"
                                readonly
                                label="Production Company"
                            ></v-text-field>
                        </div>
                        <div class="tw-pb-2">
                            <v-text-field
                                :value="production.production_office_address[0]?.address1"
                                :outlined="false"
                                readonly
                                label="Address"
                            ></v-text-field>
                        </div>
                        <div class="tw-flex tw-gap-3 tw-pb-2">
                            <v-text-field
                                :value="production.production_office_address[0]?.city"
                                :outlined="false"
                                readonly
                                label="City"
                                class="tw-w-1/2"
                            ></v-text-field>
                            <v-text-field
                                :value="production.production_office_address[0]?.province?.name"
                                :outlined="false"
                                readonly
                                label="Province"
                                class="tw-w-1/2"
                            ></v-text-field>
                        </div>
                        <div class="tw-flex tw-gap-3">
                            <v-text-field
                                :value="production.production_office_address[0]?.postal_code"
                                :outlined="false"
                                readonly
                                label="Postal Code"
                                class="tw-w-1/2"
                            ></v-text-field>
                            <v-text-field
                                :value="production.production_office_address[0]?.country?.name"
                                :outlined="false"
                                readonly
                                label="Country"
                                class="tw-w-1/2"
                            ></v-text-field>
                        </div>
                    </div>
                </internal-table-section>

                <internal-table-section :has-button="false" section-title="Head Office Address" class="tw-w-full">
                    <div class="tw-flex tw-flex-col tw-px-4 tw-pt-3">
                        <div class="tw-pb-2">
                            <v-text-field
                                :value="production.head_office_address[0]?.address1"
                                :outlined="false"
                                readonly
                                label="Address"
                            ></v-text-field>
                        </div>
                        <div class="tw-flex tw-gap-3 tw-pb-2">
                            <v-text-field
                                :value="production.head_office_address[0]?.city"
                                :outlined="false"
                                readonly
                                label="City"
                                class="tw-w-1/2"
                            ></v-text-field>
                            <v-text-field
                                :value="production.head_office_address[0]?.province?.name"
                                :outlined="false"
                                readonly
                                label="Province"
                                class="tw-w-1/2"
                            ></v-text-field>
                        </div>
                        <div class="tw-flex tw-gap-3">
                            <v-text-field
                                :value="production.head_office_address[0]?.postal_code"
                                :outlined="false"
                                readonly
                                label="Postal Code"
                                class="tw-w-1/2"
                            ></v-text-field>
                            <v-text-field
                                :value="production.head_office_address[0]?.country?.name"
                                :outlined="false"
                                readonly
                                label="Country"
                                class="tw-w-1/2"
                            ></v-text-field>
                        </div>
                    </div>
                </internal-table-section>

                <internal-table-section :has-button="false" class="tw-w-full">
                    <div class="tw-flex tw-justify-between tw-gap-3 tw-items-center">
                        <div class="tw-w-1/4">
                            <v-text-field
                                :value="production.print_color"
                                :outlined="false"
                                readonly
                                hide-details
                                label="Print Color"
                            ></v-text-field>
                        </div>
                        <div :class="(production.include_report)?'tw-text-secondary':'tw-text-gray-300'">Production Report</div>
                    </div>
                </internal-table-section>
            </div>

            <div class="tw-flex tw-flex-col tw-w-full md:tw-w-1/2 tw-gap-4"><!-- right side -->
                <internal-table-section :has-button="false" section-title="Production Staff" class="tw-w-full">
                    <smart-table
                        id="production_staff_list"
                        endpoint="productionstaff.list"
                        :headers="headers"
                        :items-per-page="5"
                        :footer-props="{
                            'items-per-page-options': [5, 10, 20, 30]
                        }"
                        :display_fields="displayed_column_names"
                        flat
                        ref="production_staff_list"
                    >
                        <template v-slot:item.staff_role.name="{ isMobile, item, header, value, index}">
                            <div class="tw-text-base">{{ item.staff_role.name}}</div>
                        </template>
                        <template v-slot:item.name="{ isMobile, item, header, value, index}">
                            <div class="tw-text-base">{{ item.name }}</div>
                        </template>
                    </smart-table>
                </internal-table-section>


                <internal-table-section button-text="Save" section-title="Production Report Comments" @button-clicked="saveComment" :is-loading="saveLoading" class="tw-w-full tw-h-full">
                    <div class="tw-flex tw-flex-col tw-pt-3">
                        <div class="tw-pb-3">
                            <v-textarea
                                v-model="production.note"
                                placeholder="Production Report Comments"
                                auto-grow
                                :error-messages="errors?.note"
                                hide-details="auto"
                                outlined
                                dense
                                rows="1"
                            ></v-textarea>
                        </div>
                        <h4 class="tw-text-secondary">Non-Print Comments</h4>
                        <div class="tw-py-3">
                            <v-textarea
                                v-model="production.non_print_note"
                                placeholder="Non-Print Comments"
                                auto-grow
                                class="tw-pb-3"
                                :error-messages="errors?.non_print_note"
                                hide-details="auto"
                                outlined
                                dense
                                rows="5"
                            ></v-textarea>
                        </div>
                    </div>

                </internal-table-section>

            </div>
        </div>
    </div>

</template>

<script>
    import SmartTable from "@/Generic/SmartTable";
    import InternalHeader from "@/Generic/InternalHeader";
    import InternalTableSection from "@/Generic/InternalTableSection";

    export default {
        name: "ProductionsShowOverview",
        components: {
            SmartTable,
            InternalHeader,
            InternalTableSection,
        },
        props: {
            'input': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'constants': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
        },
        data() {
            return {
                production: this.input,
                constant: this.constants,
                saveLoading: false,
                filters: {
                    production_id: this.input.id,
                },
                errors: null,
            }
        },
        computed: {
            headers() {
                return [
                    {value: 'staff_role.name',              text: 'Staff Position',                 align: `start`, sortable: false,    filterable: true,   optional: false, },
                    {value: 'name',                         text: 'Name',                           align: `start`, sortable: true,    filterable: true,   optional: false, },
                    {value: 'production_id',                text: 'production_id',                  align: `start`, sortable: false,   filterable: true,   search: this?.filters?.production_id, optional: false, },
                ]
            },
            displayed_column_names() {
                let headers_to_display = this.headers.filter(header => this.should_column_be_displayed(header.value))
                return headers_to_display.map(header => header.value)
            },
            isUserAdminOrStaff() {
                return this.$page.user.role === 'ADMIN' || this.$page.user.role === 'STAFF';
            },
        },
        methods: {
            should_column_be_displayed(column) {
                let required_headers = ['staff_role.name', 'name']
                return required_headers.includes(column)
            },
            saveComment() {
                let url = route('productionscomments.update', this.production.id)
                let data = {
                    'note': this.production.note,
                    'non_print_note': this.production.non_print_note,
                }

                axios({
                    method: 'put',
                    url: url,
                    data: data,
                    onUploadProgress: (evt) => {
                        this.saveLoading = !this.saveLoading
                    },
                    onDownloadProgress: (evt) => {
                        this.saveLoading = !this.saveLoading
                    },
                })
                    .then(response =>
                    {
                        if (response.data.success) {
                            this.$root.is_dirty = false
                            this.$root.snackbar.success('Comments have been saved')
                            this.$root.is_dirty = false
                            this.saveLoading = false
                            this.$emit('successful-production-note-save')
                        } else if( response.data?.error ) {
                            throw (response.data?.error)
                        } else {
                            throw ('Unknow error.')
                        }
                    })
                    .catch((error) => {
                        if( error?.response ) {
                            this.$root.snackbar.error(error.response.data.message)
                            this.errors = error.response?.data?.errors
                        } else {
                            console.log(error)
                            this.$root.snackbar.error(error)
                        }
                        this.saveLoading = false
                    })
            },
        }
    }
</script>
